import { fr } from 'date-fns/locale';
import DatePicker, { registerLocale } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import { BasicInput } from './BasicInput';
import { TotemLabel } from './TotemLabel';
registerLocale('fr', fr);

type TotemDatePickerType = {
    className?: string;
    label?: string;
    sublabel?: string;
    selected: Date | null;
    showTimeInput?: boolean;
    isClearable?: boolean;
    isDisabled?: boolean;
    shouldAllowPastDates?: boolean;
    onChange: (date: Date | null) => void;
};

export const TotemDatePicker = ({
    className,
    label,
    sublabel,
    selected,
    isClearable = false,
    isDisabled,
    onChange,
    showTimeInput = false,
    shouldAllowPastDates = true,
}: TotemDatePickerType) => {
    const handleDateChange = (date: any) => {
        if (Array.isArray(date)) {
            return;
        }
        onChange(date);
    };
    const dateFormat = showTimeInput ? 'dd/MM/yyyy - HH:mm:ss' : 'dd/MM/yyyy';

    const today = new Date();
    const isDateAfterToday = (date: Date) => {
        return date > today;
    };

    return (
        <div className="flex flex-col w-full gap-[5px]">
            {label ? <TotemLabel>{label}</TotemLabel> : null}
            {sublabel ? <span className="text-muted-foreground text-[13px]">{sublabel}</span> : null}
            <div>
                <DatePicker
                    selected={selected}
                    onChange={(date: any) => handleDateChange(date)}
                    locale="fr"
                    disabled={isDisabled}
                    dateFormat={dateFormat}
                    className={className}
                    customInput={<BasicInput />}
                    wrapperClassName="totem-date-picker"
                    showTimeInput={showTimeInput}
                    timeInputLabel={showTimeInput ? 'Heure : ' : undefined}
                    isClearable={isClearable}
                    filterDate={(date) => shouldAllowPastDates || isDateAfterToday(date)}
                    preventOpenOnFocus
                />
            </div>
        </div>
    );
};
